import React from 'react';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import Landing from './Pages/Landing/Landing';
import Gastronomia from './Pages/Gastronomia/Gastronomia';
import Home from './Pages/Home/Home';
import Entretenimiento from './Pages/Entretenimiento/Entretenimiento';
import Paloko from './Pages/Entretenimiento/sites/Paloko';
import MiniGolf from './Pages/Entretenimiento/sites/MiniGolf';
import Eventos from './Pages/Eventos/Eventos';
import QuienesSomos from './Pages/Quienes_Somos/QuienesSomos';
import { MenuQR } from './Pages/MenuQr/MenuQR';
import NotFound from './Components/NotFound';
import IronDriver from './Pages/Entretenimiento/sites/IronDriver';


//Proximamente type={"obras-breves"}/>
//<Route exact path={'/arte'} element={<Arte/>}/>
//<Route exact path={'/moda'} element={<Moda/>}/>
//<Route exact path={'/entretenimiento/obras-breves'} element={<ObrasBreves/>}/>
function App() {
  return (
    <Router>
      <Routes>
        <Route exact path={'/'} element={<Landing/>}/>
        <Route exact path={'/home'} element={<Home/>}/>
        <Route exact path={'/gastronomia'} element={<Gastronomia/>}/>
        <Route exact path={'/entretenimiento'} element={<Entretenimiento/>}/>
        <Route exact path={'/entretenimiento/paloko'} element={<Paloko/>}/>
        <Route exact path={'/entretenimiento/minigolf'} element={<MiniGolf/>}/>
        <Route exact path={'/entretenimiento/iron-driver'} element={<IronDriver/>}/>
        <Route exact path={'/eventos'} element={<Eventos/>}/>
        <Route exact path={'/quienes-somos'} element={<QuienesSomos/>}/>
        <Route exact path={'/menuqr/:name'} element={<MenuQR/>}/>
        <Route path="*" element={<NotFound/>}/>
      </Routes>
    </Router>
  );
}

export default App;
